import { label_style } from "../../features";
import Select from "react-select";
import React from "react";
import { safe_get } from "../../report-visuals";
import { useStore } from "../../helpers";
import { useTranslation } from "react-i18next";

type TargetFiltersProps = {
    value: string;
    onChange: (value: string) => void;
};

export const TargetFilters = ({ value, onChange }: TargetFiltersProps) => {
    const rootStore = useStore();
    const { projectStore } = rootStore;

    const profileOptions = projectStore.getProjectProperty(
        "profile_questions",
        {}
    );

    const { t } = useTranslation("project_work");

    const casteOptions = safe_get(profileOptions, "caste", []);

    return (
        <div>
            <label className={label_style}>{t("Caste")}</label>

            <Select
                options={casteOptions.map((x) => ({
                    label: x.label,
                    value: x.value || x.label,
                }))}
                placeholder={t("Select Caste")}
                value={
                    value
                        ? {
                              label: value,
                              value: value,
                          }
                        : null
                }
                onChange={(val) => {
                    onChange(val?.value || "");
                }}
                className="w-full"
            />
        </div>
    );
};
